<template>
  <div
    class="event-item"
    ref="event-item"
    :style="{
      borderColor,
      backgroundColor,
      left: `${positionX}%`,
      width: `${width}%`,
    }"
    @click="$emit('click')"
    @mouseenter="(e) => $emit('hover', e)"
    @mouseleave="(e) => $emit('hover', e)"
  >
    <div class="event-item__container">
      <div class="event-item__number">{{ title }}</div>
      <div
        class="event-item__content row-item"
        v-for="(content, index) in contents"
        v-html="content"
        :key="`content-${index}`"
      ></div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import eventItemColors from '../lib/constants/event-item-colors'

export default {
  inject: ['timeSelected', 'startWeekDay', 'endWeekDay'],
  props: {
    startTime: {
      type: String,
    },
    endTime: {
      type: String,
    },
    color: {
      type: String,
      default: 'blue',
    },
    title: {
      type: String,
      required: true,
    },
    contents: {
      type: Array,
      default: () => [],
    },
  },
  emit: ['click', 'hover'],
  data() {
    return {
      eventItemColors,
      columnWidth: 120,
    }
  },
  computed: {
    borderColor() {
      return this.eventItemColors[this.color].mainColor
    },
    backgroundColor() {
      return this.eventItemColors[this.color].backgroundColor
    },
    width() {
      const startTime = this.extractTime('start', this.startTime)
      const endTime = this.extractTime('end', this.endTime)

      const startWeekDay = this.startWeekDay.clone().startOf('day')
      const endWeekDay = this.endWeekDay.clone().startOf('day').add(1, 'd')

      const eventWidthInSeconds = endTime.diff(startTime, 'seconds')
      const totalWidthInSeconds = endWeekDay.diff(startWeekDay, 'seconds')

      return (eventWidthInSeconds / totalWidthInSeconds) * 100
    },
    positionX() {
      const startTime = this.extractTime('start', this.startTime)
      const startWeekDay = this.startWeekDay.clone().startOf('day')
      const endWeekDay = this.endWeekDay.clone().add(1, 'd')

      const positionInSeconds = startTime.diff(startWeekDay, 'seconds')
      const totalWidthInSeconds = endWeekDay.clone().startOf('day').diff(startWeekDay, 'seconds')

      return (positionInSeconds / totalWidthInSeconds) * 100
    },
  },
  mounted() {
    if (this.contents.length <= 1) return

    const eventItemParentRef = this.$refs['event-item'].parentElement

    // Adjust table cell height based on the contents length
    eventItemParentRef.style.height = `${80 + (this.contents.length - 1) * 20}px`
  },
  methods: {
    extractTime(type, time) {
      let parsedTime = moment(time)

      if (type == 'start') {
        if (parsedTime.isBefore(this.startWeekDay, 'day')) {
          parsedTime = moment(this.timeSelected[0]).set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
          })
        }
      } else if (type == 'end') {
        if (parsedTime.isAfter(this.endWeekDay, 'day')) {
          parsedTime = moment(this.timeSelected[1]).set({
            hour: 23,
            minute: 59,
            second: 0,
            millisecond: 0,
          })
        }
      }

      return parsedTime
    },
  },
}
</script>
<style scoped lang="scss">
.event-item {
  width: calc(300px);
  height: fit-content; // minus padding top and bottom of the table cell
  position: absolute;
  top: 50%;
  transform: translate(0px, -50%);
  border-left-width: 4px;
  border-left-style: solid;
  border-radius: 4px;
  padding: 2px 6px;
  cursor: pointer;
  z-index: 1;

  &__container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 4px;
  }

  &__number {
    font-weight: 600;
  }

  .row-item {
    display: flex;
    align-items: center;
    gap: 4px;

    :deep(.mc-icon::before) {
      font-size: 16px;
    }
  }

  & > div,
  .row-item :deep(div) {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
